document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (this.elements.viewer) {
          let touchStartX = 0;
          let touchStartY = 0;

          this.elements.viewer.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
          }, { passive: true });

          this.elements.viewer.addEventListener('touchend', (e) => {
            if (this.mql.matches) return;
            const diffX = touchStartX - e.changedTouches[0].screenX;
            const diffY = touchStartY - e.changedTouches[0].screenY;

            if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
              if (this.elements.thumbnails) {
                const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('.thumbnail-list__item:not(.hidden)'));
                if (thumbnails.length > 1) {
                  const activeThumb = this.elements.thumbnails.querySelector('.thumbnail-list__item.is-active');
                  const currentIndex = thumbnails.indexOf(activeThumb);
                  let nextIndex = diffX > 0 ? currentIndex + 1 : currentIndex - 1;

                  if (nextIndex < 0) nextIndex = thumbnails.length - 1;
                  if (nextIndex >= thumbnails.length) nextIndex = 0;

                  const targetThumb = thumbnails[nextIndex];
                  if (targetThumb) {
                    const btn = targetThumb.querySelector('button');
                    if (btn) btn.click();
                  }
                  return;
                }
              }

              if (diffX > 0) {
                const nextBtn = this.elements.viewer.querySelector('button[name="next"]');
                if (nextBtn && !nextBtn.hasAttribute('disabled')) nextBtn.click();
              } else {
                const prevBtn = this.elements.viewer.querySelector('button[name="previous"]');
                if (prevBtn && !prevBtn.hasAttribute('disabled')) prevBtn.click();
              }
            }
          }, { passive: true });
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
        });

        // Optional: Remove list semantics for thumbnail slider on desktop
        // Comment this out if it causes visibility issues
        // if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        if (event.detail.currentElement == undefined) return;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, scrollIntoView = true) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        console.log("Activating media:", mediaId, activeMedia);

        if (!activeMedia) return;

        const isSlider = !!this.elements.viewer.slider;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          if (!isSlider) {
            element.style.display = "none";
          }
        });

        activeMedia.classList.add('is-active');
        if (!isSlider) {
          activeMedia.style.display = "block";
        }

        // ✅ Safe check for media toggle button
        const toggleButton = activeMedia.querySelector("button.product__media-toggle");
        if (toggleButton && !isSlider) toggleButton.style.display = "block";

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          const isMobile = !this.mql.matches;
          if (this.elements.thumbnails) {
            if (isMobile) {
              const originalBehavior = activeMedia.parentElement.style.scrollBehavior;
              activeMedia.parentElement.style.scrollBehavior = 'auto';
              activeMedia.parentElement.scrollLeft = 0;
              activeMedia.parentElement.scrollTo({ left: 0, behavior: 'instant' });
              activeMedia.parentElement.style.scrollBehavior = originalBehavior;
            } else {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
          }
          if (this.mql.matches && (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        // ✅ Attempt to load the deferred media (like video)
        this.playActiveMedia(activeMedia);

        // ✅ Handle thumbnail highlight and screen reader text
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
          element.classList.remove('is-active');
          element.querySelector('button').removeAttribute('aria-current');
        });

        thumbnail.classList.add('is-active');
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    });
  }
});


 document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll('.product__media video');

    videos.forEach(video => {
      // Ensure required attributes
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('loop', '');
      video.setAttribute('preload', 'auto');
      video.setAttribute('controls', '');
      video.setAttribute('controlsList', 'nodownload');

      video.muted = true;

      // Chrome mobile often blocks autoplay unless in viewport
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play().catch(err => {
              console.warn('Video autoplay blocked by browser:', err);
            });
          }
        });
      }, { threshold: 0.5 });

      observer.observe(video);
    });
  });